/**
 * ChoiceButtons - Player action buttons
 */
import React from 'react';
import { motion } from 'framer-motion';

const ChoiceButtons = ({ voices, onChoice, level = 'level_1' }) => {
  const showBlend = level === 'level_2' || level === 'level_3';

  return (
    <div className="space-y-4">
      <div className="text-center font-display text-h3 text-primary mb-4">Your Move</div>
      <div
        className={`grid grid-cols-1 ${showBlend ? 'md:grid-cols-4' : 'md:grid-cols-3'} gap-4`}
      >
        {voices[0] && (
          <motion.button
            type="button"
            className="btn-primary py-4 px-6 text-label"
            onClick={() => onChoice('trust_A')}
            whileTap={{ scale: 0.98 }}
          >
            <div className="text-2xl mb-2" aria-hidden="true">
              {voices[0].character_icon}
            </div>
            <div>Trust {voices[0].character_name}</div>
          </motion.button>
        )}

        <motion.button
          type="button"
          className="btn-secondary py-4 px-6 text-label"
          onClick={() => onChoice('wait')}
          whileTap={{ scale: 0.98 }}
        >
          <div className="text-2xl mb-2" aria-hidden="true">
            ⏸️
          </div>
          <div>Wait / Observe</div>
        </motion.button>

        {voices[1] && (
          <motion.button
            type="button"
            className="btn-primary py-4 px-6 text-label"
            onClick={() => onChoice('trust_B')}
            whileTap={{ scale: 0.98 }}
          >
            <div className="text-2xl mb-2" aria-hidden="true">
              {voices[1].character_icon}
            </div>
            <div>Trust {voices[1].character_name}</div>
          </motion.button>
        )}

        {showBlend && voices.length >= 2 && (
          <motion.button
            type="button"
            className="btn-secondary py-4 px-6 text-label border-pine text-pine"
            onClick={() => onChoice('blend')}
            whileTap={{ scale: 0.98 }}
          >
            <div className="text-2xl mb-2" aria-hidden="true">
              🔄
            </div>
            <div>Blend Both</div>
          </motion.button>
        )}
      </div>
    </div>
  );
};

export default ChoiceButtons;
